import React from 'react';
import { useSelector } from 'react-redux';
import { selectDropdownOptions } from '../../redux/slices/dropdownSlice';

export default function ShippingSelectOptions({ column, value }) {
  const managedOptions = useSelector(selectDropdownOptions);
  const options = column.dropdownType
    ? [...new Set([...managedOptions.filter((option) => option.DropdownType === column.dropdownType)
      .map((option) => option.DisplayText), ...(column.options || [])].filter(Boolean))].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
    : column.options || [];
  return <>
    <option value="">Not set</option>
    {options.map((option) => <option key={option.value ?? option} value={option.value ?? option}>{option.label ?? option}</option>)}
    {column.dropdownType && value && !options.includes(value) && <option value={value} style={{ color: 'red' }}>{value} (not in managed list)</option>}
  </>;
}
